module.exports = __webpack_public_path__ + "img/Senegal.b16ca7bc.png";